import React from 'react';
import './InformationModals.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AboutIcon } from '../../icons/Icons';

const AboutModal = ({ modal, toggle }) => {
    return (
        <Modal isOpen={modal} toggle={toggle} className="about-modal">
            <ModalHeader toggle={toggle} />
            <ModalBody>
                <AboutIcon />
                <h1>Why does Validate exist?</h1>
                <p>
                    In today’s world, startups are growing a rapidly increasing rate. As they grow
                    they often have lots of questions that need answers. Hiring talent to help you
                    solve business problems can be expensive and time consuming.
                </p>
                <p>
                    That’s why we created Validate. It’s a platform that lets startups and
                    freelancers reach out to people outside their professional network, to solve
                    problems in a quick and painless way. Validate serves as that extra perspective,
                    those extra pair of eyes, your fairy godmother.
                </p>
                <p>Scrap the endless email threads and join our community today.</p>
            </ModalBody>
            <ModalFooter />
        </Modal>
    );
};

export default AboutModal;
